import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as n } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = n((e, r) => /* @__PURE__ */ o.jsx(
  t,
  {
    ref: r,
    ...e,
    image: (s) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...s,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M24 26c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633"
          }
        )
      }
    )
  }
));
i.displayName = "AgencyAcne1Icon";
export {
  i as AgencyAcne1Icon,
  i as default
};
//# sourceMappingURL=index.js.map
